<template>
  <div>
    <b-input-group>
    <b-input class="range-input" type="number"></b-input>
      <div style="margin-right: 10px">-</div>
      <b-input class="range-input" type="number"></b-input>
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: 'TwoRangeInputs',
  props: ['value', 'options']
}
</script>

<style scoped lang="scss">
.range-input{
  max-width: 115px;
  margin-right: 10px;
}
</style>
